/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonUpdateDto
 */
export interface PersonUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonUpdateDto
     */
    birthday?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    bankAccountIBAN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonUpdateDto
     */
    bankOwner?: string | null;
}

/**
 * Check if a given object implements the PersonUpdateDto interface.
 */
export function instanceOfPersonUpdateDto(value: object): value is PersonUpdateDto {
    return true;
}

export function PersonUpdateDtoFromJSON(json: any): PersonUpdateDto {
    return PersonUpdateDtoFromJSONTyped(json, false);
}

export function PersonUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'password': json['password'] == null ? undefined : json['password'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'birthday': json['birthday'] == null ? undefined : (new Date(json['birthday'])),
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'street': json['street'] == null ? undefined : json['street'],
        'country': json['country'] == null ? undefined : json['country'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'bankAccountIBAN': json['bankAccountIBAN'] == null ? undefined : json['bankAccountIBAN'],
        'bankOwner': json['bankOwner'] == null ? undefined : json['bankOwner'],
    };
}

export function PersonUpdateDtoToJSON(json: any): PersonUpdateDto {
    return PersonUpdateDtoToJSONTyped(json, false);
}

export function PersonUpdateDtoToJSONTyped(value?: PersonUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'birthday': value['birthday'] == null ? undefined : ((value['birthday'] as any).toISOString().substring(0,10)),
        'phoneNumber': value['phoneNumber'],
        'street': value['street'],
        'country': value['country'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'bankAccountIBAN': value['bankAccountIBAN'],
        'bankOwner': value['bankOwner'],
    };
}

